import React, { useEffect, useState } from "react";
import styles from "./products.module.css";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { setMetaTags } from "../../utils/util_functions";
import { getLoading, getProducts, getRoutes } from "../../services/selectors";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../components/loader/loader";
import { SET_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { getDataFromProductRoutes } from "../../utils/util_functions";
import Slider from "../../components/slider/slider";
import ProductInfoBar from "../../components/product_info_bar/product_info_bar";
import { CURR_PRODUCT_ADD, CURR_PRODUCT_DEL } from "../../services/actions/curr_product_actions";


const ProductPage = () => {
  const routes = useSelector(getRoutes);

  const getCategoryPath = (routes, products, lastSlug) => {
    if (products.find(p => p.slug === lastSlug)) {
      return location.pathname.replace('/products', '/catalog').replace(`/${lastSlug}`, '');
    }
    return location.pathname.replace('/products', '/catalog');
  }

  const location = useLocation();
  const isLoading = useSelector(getLoading);
  const products = useSelector(getProducts);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let { slug1, slug2, slug3, slug4 } = useParams();
  const lastSlug = slug4 ? slug4 : slug3 ? slug3 : slug2 ? slug2 : slug1;

  const {
    metaTitle
  } = getDataFromProductRoutes(location.pathname, navigate, routes, lastSlug);

  const [currProduct, setCurrProduct] = useState({});
  const [currVariant, setCurrVariant] = useState(null);
  const [currCategory, setCurrCategory] = useState({});

  useEffect(() => {

    dispatch({
      type: SET_PATH_PARAMS,
      uid: '',
      token: '',
      slug1: slug1 || '',
      slug2: slug2 || '',
      slug3: slug3 || '',
      slug4: slug4 || ''
    });

    if (products.length > 0 && !isLoading && routes.some(r => r.path.startsWith('/products/'))) {
      let categoryPath = getCategoryPath(routes, products, lastSlug);
      let findProduct = products.find(p => p.path === location.pathname);
      setCurrCategory(routes.find(r => r.path === categoryPath));
      setCurrProduct(findProduct);
      dispatch({ type: CURR_PRODUCT_ADD, payload: findProduct });
      if (!currProduct && currCategory) {
        navigate(`${currCategory.path}`);
      }
      if (!currProduct && !currCategory) {
        navigate('/not-found', { replace: true });
      }
    }
    // eslint-disable-next-line
  }, [products, routes, location, isLoading, currCategory, currProduct]);


  useEffect(() => {
    setMetaTags(metaTitle);
    // eslint-disable-next-line
  }, [metaTitle,]);


  // устанавливаем и снимаем текущий продукт
  useEffect(() => {
    return () => {
      dispatch({ type: CURR_PRODUCT_DEL });
    }
    // eslint-disable-next-line
  }, []);

  const getImagesList = (object) => {
    let images = [];
    if (Object.keys(object).length > 0) {
      Object.keys(object).forEach(key => {
        if (key.includes('image') && object[key] !== null) {
          images.push({ image: object[key] });
        }
      });
    }
    return images;
  }

  const imagesSelect = (product, variant) => {
    const productImages = getImagesList(product);
    if (variant) {
      if (variant.image1 || variant.image2) {
        return getImagesList(variant);
      }
    }
    return productImages;
  }

  return (
    <main className='main'>
      {isLoading ? <Loader black={true}/> :
        <>
          {currProduct ?
            <>
              <h1 className="title">{currProduct.name}</h1>
              <div className={styles.container}>
                <div className={styles.upperContainer}>
                  <Slider
                    images={imagesSelect(currProduct, currVariant)}
                  />
                  <div className={styles.descVarContainer}>
                    <p className="text">&emsp;{currProduct.description_short}</p>
                    {currProduct.variants?.length > 0 ?
                      <div className={styles.varContainer}>
                        <h2 className={`${styles.subtitle}`}>Варианты исполнения:</h2>
                        <ul className={styles.varList}>
                          {currProduct.variants.map((v, index) => {
                            return (
                              <li key={index}>
                                <button
                                  className={`button button__medium ${currVariant?.id === v.id ? 'button__colorReverse' : ''}`}
                                  onClick={() => {
                                    setCurrVariant(currVariant === null ? v : currVariant.id === v.id ? null : v);
                                  }}
                                >
                                  {v.name}
                                </button>
                              </li>
                            )
                          })}
                        </ul>
                        {currVariant?.id ?
                          <p className="text">
                            <span className='weigth_bold'>Описание варианта.</span><br /> {currVariant.description}
                          </p>
                          : null}
                      </div> : null
                    }
                  </div>
                </div>
                <div className={styles.lowerContainer}>
                  <ProductInfoBar product={currProduct} variant={currVariant} />
                </div>
              </div>
            </> : null
          }
        </>
      }
    </main>
  );
};

export default ProductPage;
